import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type RelocationDealChatMessage = NonNullable<
  ResultOf<typeof relocationDealChatQuery>["relocationDealChat"]
>[number];

export const relocationDealChatQuery = graphql(`
  query RelocationDealChat($relocationId: ID!) {
    relocationDealChat(relocation_id: $relocationId) {
      id
      role
      content
      created_at
      user {
        id
        name
      }
    }
  }
`);
